/** @jsxImportSource @emotion/react */
import React from 'react'

const formatBalance = (amount: number) => `$${amount.toFixed(2)}`

// Both balances stacked in one narrow column rather than two more columns: the
// list is wide already. Left-aligned under fixed-width labels, so the amounts
// start at the same place on every row. Colored as the patient header colors them: what the
// patient owes in red, and a zero muted so the rows that owe something stand
// out, which is also what tells two same-named patients apart.
export const PatientBalanceCell = ({ patientBalance = 0, planBalance = 0 }: { patientBalance?: number; planBalance?: number }) => {
  const amounts = [
    { label: 'Patient', amount: patientBalance, owedColor: '#dc3545', owedWeight: 600 },
    { label: 'Plan', amount: planBalance, owedColor: '#212529', owedWeight: 400 },
  ]

  return (
    <div
      css={{
        display: 'grid',
        gridTemplateColumns: 'auto auto',
        columnGap: 6,
        justifyContent: 'start',
        alignItems: 'baseline',
        whiteSpace: 'nowrap',
        fontVariantNumeric: 'tabular-nums',
      }}>
      {amounts.map(({ label, amount, owedColor, owedWeight }) => (
        <React.Fragment key={label}>
          <strong css={{ color: '#777', fontSize: '0.7rem', textTransform: 'uppercase' }}>{label}</strong>
          <span
            data-testid={`balance-${label.toLowerCase()}`}
            css={{
              color: amount !== 0 ? owedColor : '#adb5bd',
              fontWeight: amount !== 0 ? owedWeight : 400,
            }}>
            {formatBalance(amount)}
          </span>
        </React.Fragment>
      ))}
    </div>
  )
}
